module.exports = {
	"ha": "viha",
	"id": 5.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "400"
						}
					},
					{
						"y": 93,
						"dataLabels": {
							"enabled": true,
							"format": "372"
						}
					},
					{
						"y": 90.25,
						"dataLabels": {
							"enabled": true,
							"format": "361"
						}
					},
					{
						"y": 83,
						"dataLabels": {
							"enabled": true,
							"format": "332"
						}
					},
					{
						"y": 61.5,
						"dataLabels": {
							"enabled": true,
							"format": "246"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "343"
						}
					},
					{
						"y": 92.71137026239067,
						"dataLabels": {
							"enabled": true,
							"format": "318"
						}
					},
					{
						"y": 88.0466472303207,
						"dataLabels": {
							"enabled": true,
							"format": "302"
						}
					},
					{
						"y": 79.88338192419825,
						"dataLabels": {
							"enabled": true,
							"format": "274"
						}
					},
					{
						"y": 49.56268221574344,
						"dataLabels": {
							"enabled": true,
							"format": "170"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.69211195928753,
						"dataLabels": {
							"enabled": true,
							"format": "380"
						}
					},
					{
						"y": 83.20610687022901,
						"dataLabels": {
							"enabled": true,
							"format": "327"
						}
					},
					{
						"y": 79.89821882951654,
						"dataLabels": {
							"enabled": true,
							"format": "314"
						}
					},
					{
						"y": 75.57251908396947,
						"dataLabels": {
							"enabled": true,
							"format": "297"
						}
					},
					{
						"y": 52.67175572519084,
						"dataLabels": {
							"enabled": true,
							"format": "207"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.999999999999995,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.9569892473118253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.033240997229917,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.903614457831324,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.288629737609331,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.031446540880502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.27152317880795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.95620437956204,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.30788804071247,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.94736842105263,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9755351681957207,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.414012738853502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.303030303030297,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=400"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=343"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=393"
			}
		],
		"dataTable": {
			"MSM": [
				400,
				400,
				372,
				361,
				332,
				246
			],
			"Non-MSM": [
				343,
				343,
				318,
				302,
				274,
				170
			],
			"Unknown": [
				393,
				380,
				327,
				314,
				297,
				207
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_4.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_4.json
// module id = 339
// module chunks = 0